import React from 'react';
import CatalogueLinksDialog from './CatalogueLinksDialog';
import CatalogueObjectDialog from './CatalogueObjectDialog';
import selectors from '../hooks/selectors';

const DatasetFormDialogs = ({ theme }) => {
  const { allowLinks, allowObjects } = selectors.useDatasetFormDialogs();
  return (
    <>
      {allowLinks && (<CatalogueLinksDialog theme={theme} />)}
      {allowObjects && (<CatalogueObjectDialog theme={theme} />)}
    </>
  );
};

export default DatasetFormDialogs;
